export const stringPropValidator = (value, list) => {
  const isValueInList = list.indexOf(value) !== -1

  return isValueInList
}



// WEBPACK FOOTER //
// ./src/js/utils/stringPropValidator.js